export { C as Container, I as INIT_FACTORY, R as Registry, g as getFactoryFor, p as privatize, s as setFactoryFor } from '../../../shared-chunks/registry-BJpQx6hv.js';
